import React, { useCallback } from "react";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { stripePromise } from "src/utils/stripe";
import { useCreateCheckoutSession } from "src/hooks/useCreateCheckoutSession";
import { Loader2 } from "lucide-react";

interface SendCardDollarsCheckoutProps {
  amount: number;
  onComplete: () => void;
  onSessionCreated?: () => void;
}

const SendCardDollarsCheckout: React.FC<SendCardDollarsCheckoutProps> = ({
  amount,
  onComplete,
  onSessionCreated,
}) => {
  const { mutateAsync: createCheckoutSession } = useCreateCheckoutSession();

  const fetchClientSecret = useCallback(async () => {
    const clientSecret = await createCheckoutSession(amount);
    onSessionCreated?.();
    return clientSecret;
  }, [createCheckoutSession, amount, onSessionCreated]);

  return (
    <div className="max-h-[400px] overflow-auto">
      <EmbeddedCheckoutProvider
        stripe={stripePromise}
        options={{
          fetchClientSecret,
          onComplete,
        }}
      >
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};

export const SendCardDollarsCheckoutLoading: React.FC = () => (
  <div className="h-[200px] flex items-center justify-center">
    <Loader2 className="w-8 h-8 animate-spin text-gray-400" />
  </div>
);

export default SendCardDollarsCheckout;
